import React from "react";
import Button from "components/Button";

const SubmitButton = (props) => {
  return <Button type="submit" onClick={() => {}} {...props} />;
};

export default SubmitButton;
